// extracted by mini-css-extract-plugin
export default {"headline_and_btn_box":"CreditStyles_headline_and_btn_box__9PDZG","img-full-width":"CreditStyles_img-full-width__tiurW","img-half-width":"CreditStyles_img-half-width__rMs+F"};